angular.module('st')
    .controller('crewardsManageSubscriptionController', [
        '$rootScope', '$scope', '$http', '$element',
        function ($rootScope, $scope, $http, $element) {
            var ctrl = this;
            $scope.feedback = '';
            $scope.processing = false;
            $scope.saveDisabled = true;

            ctrl.SetCreditCards = function (creditCards) {
                $scope.creditCards = creditCards;
                $rootScope.paymentMethods = creditCards;

                $scope.selectedCardToken = null;
                var temp = ctrl.GetSelectedCard();
                if (temp) {
                    $scope.selectedCardToken = ctrl.GetSelectedCard().token
                }                
                $rootScope.subscriptionPaymentToken = $scope.selectedCardToken;
            }

            ctrl.UpdatePreferences = function () {
                if ($scope.processing == false) {
                    $scope.processing = true;
                    $scope.feedback = '';
                    $scope.saveDisabled = true;
                    var token = $scope.selectedCardToken;
                    $http.post("/rpc/membership/account/payment-method/set/" + $scope.subscriptionId + "/?token=" + token)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.feedback = '';
                                $scope.processing = false;
                                $rootScope.subscriptionPaymentToken = token;
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.saveDisabled = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.processing = false;
                            $scope.saveDisabled = false;
                            $scope.feedback = 'Error occurred while trying to save settings.'
                        })
                    }
            }

            ctrl.ShowCancelModal = function(show) {
                let modal = $($element).find('.cancel-modal');
                if (show) modal.modal('show');
                else modal.modal('hide');
            };

            ctrl.ShowCancelledModal = function () {
                $($element).find('.cancelled-modal').modal('show');
            };

            ctrl.ShowReactivatedModal = function () {
                $($element).find('.reactivated-modal').modal('show');
            };

            ctrl.CancelSubscription = function () {
                if ($scope.processing == false) {
                    $scope.processing = true;
                    $scope.feedback = '';
                    $scope.saveDisabled = true;
                    $http.post("/rpc/membership/account/subscription/cancel/" + $scope.subscriptionId)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.feedback = '';
                                $scope.processing = false;
                                $scope.cancellationProcessed = true;
                                ctrl.ShowCancelModal(false);
                                ctrl.ShowCancelledModal();
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.saveDisabled = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.processing = false;
                            $scope.saveDisabled = false;
                            $scope.feedback = 'Error occurred while trying to save settings.'
                        })
                    };
            };

            ctrl.RestoreSubscription = function () {
                if ($scope.processing == false) {
                    $scope.processing = true;
                    $scope.feedback = '';
                    $scope.saveDisabled = true;
                    $http.post("/rpc/membership/account/subscription/restore/" + $scope.subscriptionId)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.feedback = '';
                                $scope.processing = false;
                                $scope.restoreProcessed = true;
                                ctrl.ShowReactivatedModal();
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.saveDisabled = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.processing = false;
                            $scope.saveDisabled = false;
                            $scope.feedback = 'Error occurred while trying to save settings.'
                        })
                    };
            };

            ctrl.GetSelectedCard = function () {
                for (i = 0; i < $scope.creditCards.length; i++) {
                    var card = $scope.creditCards[i];
                    if (card.isSelectedMethod == true) {
                        return card;
                    }
                }

                return null;
            }

            $rootScope.$on('cardAdded', function (event, cardObj) {
                $scope.creditCards.push(cardObj);
            });
            $rootScope.$on('cardRemoved', function (event, removedCardToken) {
                for (i = 0; i < $scope.creditCards.length; i++) {
                    var card = $scope.creditCards[i];
                    if (card.token == removedCardToken) {
                        $scope.creditCards.splice(i, 1);
                    }
                }
            });
            }
        ]   
    );
